import { fetchAppData, fetchTPASettings, isExperimentEnabled } from '@wix/communities-blog-client-common';
import { EXPERIMENT_MULTILINGUAL } from '@wix/communities-blog-experiments';

import { initialiseInstanceValues } from '../../common/store/instance-values/instance-values-actions';
import { getInstanceId } from '../../common/store/instance-values/instance-values-selectors';
import { fetchExperiments } from '../../common/store/experiments/experiments-actions';
import { fetchTopology } from '../../common/store/topology/topology-actions';
import { fetchTranslations } from '../../common/store/translations/translations-actions';
import { setLocale } from '../../common/store/locale/locale-actions';
import { setAppSettings } from '../../common/store/app-settings/app-settings-actions';
import { setBasicParams } from '../../common/store/basic-params/basic-params-actions';
import { setAppConfig } from '../../common/store/app-config/app-config-actions';
import { getInstance } from '../../common/controller/helpers';

export {
  initializeActions,
  initializePromisifiedActions,
  refreshDataOnLogin,
} from '../../common/controller/init-actions';

export async function initializeStoreBaseData({
  wixCodeApi,
  store,
  language,
  platformAPIs,
  config,
  bundleName,
  fedopsAppName,
  translationsName,
  context = {},
}) {
  const viewMode = wixCodeApi.window.viewMode.toLowerCase();

  store.dispatch(initialiseInstanceValues(getInstance(wixCodeApi)()));

  const instanceId = getInstanceId(store.getState());

  await Promise.all([
    store.dispatch(fetchAppData()),
    store
      .dispatch(fetchExperiments(context.experimentsPromise))
      .then(() =>
        Promise.all([
          store.dispatch(fetchTopology(instanceId)),
          isExperimentEnabled(store.getState(), EXPERIMENT_MULTILINGUAL) &&
            store.dispatch(fetchTPASettings({ language })),
        ]),
      ),
    store.dispatch(fetchTranslations(language, translationsName)),
    store.dispatch(setLocale(language)),
    store.dispatch(setAppSettings({ style: config.style.styleParams })),
  ]);

  await store.dispatch(setBasicParams({ viewMode, language, biPageNumber: platformAPIs.bi.pageNumber }));
  await store.dispatch(setAppConfig({ bundleName, fedopsAppName }));
}
